import Zzeung from "../lib/myid-sdk-client-web/lib/index";

class JavascriptHandler {
   isReady = false;

   initJavascriptHandler = () => {
      window.addEventListener("flutterInAppWebViewPlatformReady", (event) => {
         this.isReady = true;
      });
   };

   async _callHandler(handlerName: string, url?: any) {
      try {
         const response = await Zzeung._callHandler(handlerName, url);
         return response;
      } catch (error) {
         throw error;
      }
   }
}
export default new JavascriptHandler();
